// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const icon = "Icon__icon__BJWj0";
export const innerSvg = "Icon__innerSvg__puP+o";
export const lastFrame = "Icon__lastFrame__EBLAw";
export const medium = "500";
export const play = "Icon__play__nGK2R";
export const playable = "Icon__playable__twHUF";
export const regular = "400";
export const rotating = "Icon__rotating__Olbdg";
export const rotation = "Icon__rotation__WhW9L";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";